<div class="slider-layout">
    <div class="slider-container" #slidercontainer>
        <div class="slider-track"></div>
        <div class="slider-track-fill"></div>
        <div class="slider-thumb" (mousedown)="dragstart($event)" #sliderthumb>
            <div class="track-thumb"></div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/slider/slider.html